angular
  .module('landingPage')
  .directive('giArchivalCalendarDatePicker', ($window, t) => ({
    restrict: 'E',
    templateUrl: 'getty/archival_calendar_date_picker.html.slim',
    replace: true,

    scope: {
      currentMonth: '@',
      currentYear: '@',
      years: '=',
      queryPlaceholder: '@',
    },

    link(scope, element, attrs) {
      element.on('$destroy', () => scope.$destroy());

      scope.init = function () {
        scope.t = t;

        scope.yearsOptions = scope.years;

        scope.monthsOptions = [
          { value: 1, text: t('january') },
          { value: 2, text: t('february') },
          { value: 3, text: t('march') },
          { value: 4, text: t('april') },
          { value: 5, text: t('may') },
          { value: 6, text: t('june') },
          { value: 7, text: t('july') },
          { value: 8, text: t('august') },
          { value: 9, text: t('september') },
          { value: 10, text: t('october') },
          { value: 11, text: t('november') },
          { value: 12, text: t('december') },
        ];

        scope.model = {
          listOfMonths: scope.monthsOptions,
          listOfYears: scope.yearsOptions,
        };

        scope.selectedMonth = scope.monthsOptions[scope.currentMonth - 1];
        return (scope.selectedYear = scope.currentYear);
      };

      scope.nextMonth = function () {
        if (scope.selectedMonth.value === 12) {
          scope.selectedMonth = scope.monthsOptions[0];
          if (scope.selectedYear !== scope.years[0]) {
            scope.selectedYear++;
          }
        } else {
          scope.selectedMonth = scope.monthsOptions[scope.selectedMonth.value];
        }
        return scope.searchByDate();
      };

      scope.previousMonth = function () {
        if (scope.selectedMonth.value === 1) {
          scope.selectedMonth = scope.monthsOptions[11];
          if (scope.selectedYear !== scope.years[scope.years.length - 1]) {
            scope.selectedYear--;
          }
        } else {
          scope.selectedMonth =
            scope.monthsOptions[scope.selectedMonth.value - 2];
        }
        return scope.searchByDate();
      };

      scope.goToUrl = (url) => ($window.location = url);

      scope.searchByDate = function () {
        const url =
          '/editorial/archival-calendar/' +
          scope.selectedYear +
          '/' +
          scope.selectedMonth.value;
        return scope.goToUrl(url);
      };

      return scope.init();
    },
  }));
